import { useState } from 'react';
import { FiAward, FiUsers, FiLayers } from 'react-icons/fi';
import SectionHeading from './SectionHeading';
import useReveal from './useReveal';

const values = [
  { icon: FiAward, label: 'Quality first' },
  { icon: FiUsers, label: 'True collaboration' },
  { icon: FiLayers, label: 'Modern stack' },
];

function Aboutminatechnologies() {
  const [expanded, setExpanded] = useState(false);
  const ref = useReveal();

  return (
    <div ref={ref} className="section-pad bg-surface">
      <div className="wrap">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <SectionHeading
              eyebrow="About us"
              title={<>Welcome to <span className="text-gradient">Mina Technologies</span></>}
            />
            <ul className="reveal mt-8 flex flex-wrap gap-2" data-reveal style={{ '--d': '80ms' }}>
              {values.map(({ icon: Icon, label }) => (
                <li
                  key={label}
                  className="inline-flex items-center gap-2 rounded-full border border-line bg-surface-2 px-4 py-2 text-sm font-medium text-ink"
                >
                  <Icon className="text-brand" /> {label}
                </li>
              ))}
            </ul>
          </div>

          <div className="reveal space-y-5 text-muted lg:col-span-7 lg:pt-12" data-reveal style={{ '--d': '120ms' }}>
            <p className="text-lg text-ink">
              At Mina Technologies, we are passionate about creating innovative solutions that drive digital
              transformation for businesses around the world. With a team of highly skilled developers, designers, and
              technology enthusiasts, we strive to deliver exceptional software products and services that exceed our
              clients' expectations.
            </p>
            <p>
              Our mission is to empower businesses by harnessing the power of technology. We believe that software,
              web, and mobile applications have the potential to revolutionize industries, streamline processes, and
              enhance user experiences. Therefore, we work closely with our clients to understand their unique
              challenges and goals, and then leverage our expertise to develop tailored solutions that address their
              specific needs.
            </p>
            {expanded && (
              <div className="fade-in space-y-5">
                <p>
                  At the core of our company is a commitment to quality and excellence. We adhere to industry best
                  practices and employ the latest development methodologies to ensure that our projects are executed
                  flawlessly. Our team stays up-to-date with the latest trends and technologies, allowing us to deliver
                  cutting-edge solutions that give our clients a competitive edge in the market.
                </p>
                <p>
                  Collaboration is key to our success. We believe in building strong partnerships with our clients,
                  working hand-in-hand throughout the development process. We value open communication and
                  transparency, ensuring that our clients are involved at every stage and have full visibility into the
                  progress of their projects. Our goal is to build long-term relationships based on trust, reliability,
                  and mutual success.
                </p>
              </div>
            )}
            <button
              type="button"
              className="font-semibold text-brand underline-offset-4 hover:underline"
              onClick={() => setExpanded(!expanded)}
              aria-expanded={expanded}
            >
              {expanded ? 'Read less' : 'Read more'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Aboutminatechnologies;
